import { reviewApi as eatsReviewApi } from '@noor/eats-api';
import { REVIEWS_PAGE_SIZE } from '../config/reviews';
import { toReview } from '../lib/map-review';
import type { Review } from '../model/schema';

/**
 * Reviews as the merchant screen reads them. Wraps `@noor/eats-api`'s wire
 * client and maps each payload into the screen's own row shape, so no
 * snake_case field or UUID order id reaches a widget.
 */
export const reviewApi = {
  /**
   * Every review across the merchant's branches.
   *
   * `by-merchant`, not the branch-scoped `reviews` route: the design's screen
   * carries no branch picker and names no branch per row, so it is the whole
   * merchant's feedback. The endpoint takes no merchant id — the token carries
   * it (CLAUDE.md §8).
   */
  async list(options?: { signal?: AbortSignal }): Promise<Review[]> {
    const result = await eatsReviewApi.listByMerchant(
      { limit: REVIEWS_PAGE_SIZE },
      options,
    );
    return result.list.map(toReview);
  },
};
